import axiosInstance from '../api/axiosInstance';

/**
 * authService — Login / Logout API calls
 *
 * login()  → POST /Auth/login  → { emailId, password }
 */

// Send emailId + password, get back a token for normal system user
export const login = (credentials) => {
  return axiosInstance.post('/Auth/login', credentials).then((res) => res.data);
};

// Send emailId + password, get back a token for customer importer
export const customerLogin = (credentials) => {
  return axiosInstance.post('/CustomerAuth/login', credentials).then((res) => res.data);
};

// Forgot Password (System User) → POST /Auth/forgot-password → { emailId }
export const forgotPassword = (payload) => {
  return axiosInstance.post('/Auth/forgot-password', payload).then((res) => res.data);
};

// Reset Password (System User) → POST /Auth/reset-password → { emailId, otp, newPassword, confirmPassword }
export const resetPassword = (payload) => {
  return axiosInstance.post('/Auth/reset-password', payload).then((res) => res.data);
};

// Forgot Password (Customer/Importer) → POST /CustomerAuth/forgot-password → { emailId }
export const customerForgotPassword = (payload) => {
  return axiosInstance.post('/CustomerAuth/forgot-password', payload).then((res) => res.data);
};

// Reset Password (Customer/Importer) → POST /CustomerAuth/reset-password → { emailId, otp, newPassword, confirmPassword }
export const customerResetPassword = (payload) => {
  return axiosInstance.post('/CustomerAuth/reset-password', payload).then((res) => res.data);
};

